<template>
  <pt-doctor-table class="pt-doctor-tablee__withData" ref="table" :tableLabels="tableLabels" :tableData="tableData"
   @getTableData="getTableData" :totalNumber="totalNumber" :isOutside="isOutside">
      <slot/>
  </pt-doctor-table>
</template>

<script>
import PtDoctorTable from './index'
export default {
  name: 'pt-doctor-table__withData',
  components: {
    'pt-doctor-table': PtDoctorTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      isOutside: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (this.isFromRouter) {
          this.isOutside = true
          this.getTableData(this.page)
        } else {
          this.resetPage()
        }
      }
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      let data = {
        ...this.paramsData,
        pageableParam: {
          page: this.page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('getDoctorList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取医生列表失败')
      })
    }

  }
}
</script>
